import { useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { BuyerCallSession } from "@/components/BuyerCallSession";

const CallPage = () => {
  const { transactionId } = useParams();
  if (!transactionId) return null;
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <Navbar />
      <BuyerCallSession transactionId={transactionId} variant="page" />
    </div>
  );
};

export default CallPage;
